import { render, staticRenderFns } from "./MatchPairSlideOption.vue?vue&type=template&id=2ba046c0&scoped=true&"
import script from "./MatchPairSlideOption.vue?vue&type=script&lang=js&"
export * from "./MatchPairSlideOption.vue?vue&type=script&lang=js&"
import style0 from "./MatchPairSlideOption.vue?vue&type=style&index=0&id=2ba046c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba046c0",
  null
  
)

export default component.exports